import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { useState } from 'react';
import { functionUtils } from 'utils';
import FxPickupDateNoticePopup from '../popups/FxPickupDateNoticePopup';

const FxPickupDateNoticeModal = ({ isShow, content, action, actionClose }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const [contentKey, setContentKey] = useState(content);
  const [buttonLabel1, setButtonLabel1] = useState(
    contentKey === 'popup_fx_pickup_date_notice_message_1'
      ? ''
      : t('button_fx_holiday_popup_close_button')
  );
  const [buttonLabel2, setButtonLabel2] = useState(
    t('button_fx_holiday_popup_ok_button')
  );

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  const handleOnTest = (testCase) => {
    switch (testCase) {
      case 1:
        setContentKey('popup_fx_pickup_date_notice_message_1');
        setButtonLabel1('');
        setButtonLabel2(t('button_ok'));
        break;
      case 2:
        setContentKey('popup_fx_pickup_date_notice_message_2');
        setButtonLabel1(t('feol_modal_holiday_btn_02'));
        setButtonLabel2(t('button_ok'));
        break;
    }
  };

  return (
    <FxPickupDateNoticePopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
      }}
      content={t(contentKey)}
      buttonLabel1={buttonLabel1}
      onClose={handleOnClose}
      buttonLabel2={buttonLabel2}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    >
      {/* <button onClick={() => handleOnTest(1)}>Test 15/12-22/12</button> */}
      {/* <button onClick={() => handleOnTest(2)}>Test 23/12-01/01</button> */}
    </FxPickupDateNoticePopup>
  );
};

export default FxPickupDateNoticeModal;
